import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { House, Images, Wrench, Calculator, Handshake } from '@phosphor-icons/react';
import { haptic } from '../utils/haptic';

const navItems = [
  { path: '/', label: 'Home', icon: House },
  { path: '/portfolio', label: 'Portfolio', icon: Images },
  { path: '/tools', label: 'Tools', icon: Wrench },
  { path: '/quote', label: 'Quote', icon: Calculator },
  { path: '/collaborate', label: 'Contact', icon: Handshake },
];

const hiddenPaths = ['/admin'];

export const BottomNav = () => {
  const { pathname } = useLocation();

  if (hiddenPaths.some(p => pathname.startsWith(p))) return null;

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 z-[10000] md:hidden bg-white/90 backdrop-blur-xl border-t border-black/5 safe-area-bottom"
      data-testid="bottom-nav"
    >
      <div className="flex items-center justify-around h-16 px-1">
        {navItems.map(({ path, label, icon: Icon }) => {
          const isActive = path === '/' ? pathname === '/' : pathname.startsWith(path);
          return (
            <Link
              key={path}
              to={path}
              onClick={() => haptic('nav')}
              className={`flex flex-col items-center justify-center gap-0.5 w-16 py-1.5 transition-colors ${
                isActive ? 'text-obsidian' : 'text-concrete'
              }`}
              data-testid={`bottom-nav-${label.toLowerCase()}`}
            >
              <Icon weight={isActive ? 'fill' : 'regular'} className="w-5 h-5" />
              <span className="text-[9px] font-semibold uppercase tracking-wider leading-none">{label}</span>
              {isActive && <span className="w-1 h-1 rounded-full bg-bronze mt-0.5" />}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
